import React, { Component } from 'react';
import UA from '../../utils/ua';
import DocumentTitle from 'react-document-title';

import './style.less';

const img1 = 'https://oss.aircourses.com/web/client/diamond/pc.png';
const img2 = 'https://oss.aircourses.com/web/client/diamond/pad.png';

class DiamondShop extends Component {
    render(){
        const img = UA.winClient? img1 : img2;
        return(
            <DocumentTitle title={'钻石商城'}>
                <div className="container diamondShop">
                    <img src={img} alt="钻石商城"/>
                </div>
            </DocumentTitle>
        )
    }
}

export default DiamondShop;



// WEBPACK FOOTER //
// ./src/components/diamondShop/index.jsx